import { getRequest, postRequest, putRequest } from "api/axiosClient";
import { BaseParamsRequest } from "api/request/basParams.request";
import { GetDraftProviderOptionsRequestParams } from "api/request/draftRequest.request";
import {
  GetDraftResponseType,
  UpdateDraftResponseType,
  ConvertDraftResponseType,
  GetDraftProviderOptionsResponseType,
} from "api/response";

const { REACT_APP_CARGOBASE_BASE_URL } = import.meta.env;
const baseURL = `${REACT_APP_CARGOBASE_BASE_URL}/draft-request`;

const convertDraft = (id: string, isQuickRequest = false, body: Record<string, unknown> = {}) => {
  const url = `${baseURL}/${id}/${isQuickRequest ? "create-quick-request" : "create-quote-request"}`;
  return postRequest<ConvertDraftResponseType>(url, body);
};

const getDraft = (id: string, isQuickRequest = false) => {
  const url = `${baseURL}/${isQuickRequest ? "quick-request" : "quote-request"}/${id}`;
  return getRequest<GetDraftResponseType>(url);
};
const getDraftProviderOptions = (id: string, config: BaseParamsRequest<GetDraftProviderOptionsRequestParams>) =>
  getRequest<GetDraftProviderOptionsResponseType>(`${baseURL}/${id}/provider-options`, config);

const updateDraft = (payload: UpdateDraftResponseType, id: string, isQuickRequest = false, config = {}) => {
  const url = isQuickRequest ? `${baseURL}/quick-request/${id}` : `${baseURL}/quote-request/${id}`;
  return putRequest<UpdateDraftResponseType>(url, payload, config);
};

export { convertDraft, getDraft, getDraftProviderOptions, updateDraft };
